var WikiStructure = {
    Header: 'Header',
    Paragraph: 'Paragraph',
    Image: 'Image',
    Table: 'Table',
    List: 'List',
    Button: 'Button',
    Html: 'Html',
    NestedList: 'Nestedlist',
};

export { WikiStructure };
